module.exports = __webpack_public_path__ + "img/b89fc313f5a26531d81864a4d993a780.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/logo_transparent.png
// module id = 245
// module chunks = 0